import { useSnackbar } from 'notistack'
import React, { FC, useState } from 'react'
import { CabinetSizesSubType, CategoryPropsType, CornerCabinetSizesSubType } from '../../../api/appAPI'
import { EnqueueSnackbarType, showMessage } from '../../common/Helpers'
import CategoryUIBox from './CategoryUIBox'
import CornerCategoryUIBox from './CornerCategoryUIBox'

interface IProps {

    addCategory(categoryProps: CategoryPropsType, enqueueSnackbar: EnqueueSnackbarType): void
}

const DefineCategory: FC<IProps> = (props) => {
    const [name, setName] = useState('')
    const [displayName, setDisplayName] = useState('')
    const [forCorner, setForCorner] = useState(false)

    const [activeRole, setActiveRole] = useState('retail')

    const [retail, setRetail] = useState<CabinetSizesSubType>({ width: { values: [], default: 0 }, height: { values: [], default: 0 }, depth: { values: [], default: 0 } })
    const [dealer, setDealer] = useState<CabinetSizesSubType>({ width: { values: [], default: 0 }, height: { values: [], default: 0 }, depth: { values: [], default: 0 } })
    const [designer, setDesigner] = useState<CabinetSizesSubType>({ width: { values: [], default: 0 }, height: { values: [], default: 0 }, depth: { values: [], default: 0 } })

    const [retailCorner, setRetailCorner] = useState<CornerCabinetSizesSubType>({ width1: { values: [], default: 0 }, width2: { values: [], default: 0 }, backWidth1: { values: [], default: 0 }, backWidth2: { values: [], default: 0 }, height: { values: [], default: 0 }, depth1: { values: [], default: 0 }, depth2: { values: [], default: 0 } })
    const [dealerCorner, setDealerCorner] = useState<CornerCabinetSizesSubType>({ width1: { values: [], default: 0 }, width2: { values: [], default: 0 }, backWidth1: { values: [], default: 0 }, backWidth2: { values: [], default: 0 }, height: { values: [], default: 0 }, depth1: { values: [], default: 0 }, depth2: { values: [], default: 0 } })
    const [designerCorner, setDesignerCorner] = useState<CornerCabinetSizesSubType>({ width1: { values: [], default: 0 }, width2: { values: [], default: 0 }, backWidth1: { values: [], default: 0 }, backWidth2: { values: [], default: 0 }, height: { values: [], default: 0 }, depth1: { values: [], default: 0 }, depth2: { values: [], default: 0 } })

    const { enqueueSnackbar } = useSnackbar()

    const handleNameChange = (event: React.ChangeEvent<{ value: string }>) => {
        setName(event.target.value.replace(/['"]/, ''))
    }

    const handleDisplayNameChange = (event: React.ChangeEvent<{ value: string }>) => {
        setDisplayName(event.target.value.replace(/['"]/, ''))
    }

    const handleCreateClick = () => {
        if (name === '') {
            showMessage(enqueueSnackbar, "Enter category name")
            return
        }

        if (retail.width.values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of width of retail')
            return
        }
        if (!retail.width.values.includes(retail.width.default)) {
            showMessage(enqueueSnackbar, 'Choose default value for width of retail')
            return
        }
        if (retail.height.values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of height of retail')
            return
        }
        if (!retail.height.values.includes(retail.height.default)) {
            showMessage(enqueueSnackbar, 'Choose default value for height of retail')
            return
        }
        if (retail.depth.values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of depth of retail')
            return
        }
        if (!retail.depth.values.includes(retail.depth.default)) {
            showMessage(enqueueSnackbar, 'Choose default value for depth of retail')
            return
        }


        if (dealer.width.values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of width of dealer')
            return
        }
        if (!dealer.width.values.includes(dealer.width.default)) {
            showMessage(enqueueSnackbar, 'Choose default value for width of dealer')
            return
        }
        if (dealer.height.values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of height of dealer')
            return
        }
        if (!dealer.height.values.includes(dealer.height.default)) {
            showMessage(enqueueSnackbar, 'Choose default value for height of dealer')
            return
        }
        if (dealer.depth.values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of depth of dealer')
            return
        }
        if (!dealer.depth.values.includes(dealer.depth.default)) {
            showMessage(enqueueSnackbar, 'Choose default value for depth of dealer')
            return
        }

        if (designer.width.values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of width of designer')
            return
        }
        if (!designer.width.values.includes(designer.width.default)) {
            showMessage(enqueueSnackbar, 'Choose default value for width of designer')
            return
        }
        if (designer.height.values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of height of designer')
            return
        }
        if (!designer.height.values.includes(designer.height.default)) {
            showMessage(enqueueSnackbar, 'Choose default value for height of designer')
            return
        }
        if (designer.depth.values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of depth of designer')
            return
        }
        if (!designer.depth.values.includes(designer.depth.default)) {
            showMessage(enqueueSnackbar, 'Choose default value for depth of designer')
            return
        }

        const categoryProps = {
            name,
            forCorner,
            retail,
            dealer,
            designer
        } as CategoryPropsType

        props.addCategory(categoryProps, enqueueSnackbar)

        setName('')
        setRetail({ width: { values: [], default: 0 }, height: { values: [], default: 0 }, depth: { values: [], default: 0 } })
        setDealer({ width: { values: [], default: 0 }, height: { values: [], default: 0 }, depth: { values: [], default: 0 } })
        setDesigner({ width: { values: [], default: 0 }, height: { values: [], default: 0 }, depth: { values: [], default: 0 } })
    }

    const handleCornerCreateClick = () => {
        if (name === '') {
            showMessage(enqueueSnackbar, "Enter category name")
            return
        }

        if (retailCorner.width1.values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of width1 of retail')
            return
        }
        if (!retailCorner.width1.values.includes(retailCorner.width1.default)) {
            showMessage(enqueueSnackbar, 'Choose default value for width1 of retail')
            return
        }
        if (retailCorner.width2.values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of width2 of retail')
            return
        }
        if (!retailCorner.width2.values.includes(retailCorner.width2.default)) {
            showMessage(enqueueSnackbar, 'Choose default value for width2 of retail')
            return
        }

        if (retailCorner.height.values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of height of retail')
            return
        }
        if (!retailCorner.height.values.includes(retailCorner.height.default)) {
            showMessage(enqueueSnackbar, 'Choose default value for height of retail')
            return
        }

        if (retailCorner.depth1.values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of depth1 of retail')
            return
        }
        if (!retailCorner.depth1.values.includes(retailCorner.depth1.default)) {
            showMessage(enqueueSnackbar, 'Choose default value for depth1 of retail')
            return
        }
        if (retailCorner.depth2.values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of depth2 of retail')
            return
        }
        if (!retailCorner.depth2.values.includes(retailCorner.depth2.default)) {
            showMessage(enqueueSnackbar, 'Choose default value for depth2 of retail')
            return
        }

        if (retailCorner.backWidth1.values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of backWidth1 of retail')
            return
        }
        if (!retailCorner.backWidth1.values.includes(retailCorner.backWidth1.default)) {
            showMessage(enqueueSnackbar, 'Choose default value for backWidth1 of retail')
            return
        }
        if (retailCorner.backWidth2.values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of backWidth2 of retail')
            return
        }
        if (!retailCorner.backWidth2.values.includes(retailCorner.backWidth2.default)) {
            showMessage(enqueueSnackbar, 'Choose default value for backWidth2 of retail')
            return
        }

        if (dealerCorner.width1.values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of width1 of dealer')
            return
        }
        if (!dealerCorner.width1.values.includes(dealerCorner.width1.default)) {
            showMessage(enqueueSnackbar, 'Choose default value for width1 of dealer')
            return
        }
        if (dealerCorner.width2.values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of width2 of dealer')
            return
        }
        if (!dealerCorner.width2.values.includes(dealerCorner.width2.default)) {
            showMessage(enqueueSnackbar, 'Choose default value for width2 of dealer')
            return
        }

        if (dealerCorner.height.values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of height of dealer')
            return
        }
        if (!dealerCorner.height.values.includes(dealerCorner.height.default)) {
            showMessage(enqueueSnackbar, 'Choose default value for height of dealer')
            return
        }

        if (dealerCorner.depth1.values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of depth1 of dealer')
            return
        }
        if (!dealerCorner.depth1.values.includes(dealerCorner.depth1.default)) {
            showMessage(enqueueSnackbar, 'Choose default value for depth1 of dealer')
            return
        }
        if (dealerCorner.depth2.values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of depth2 of dealer')
            return
        }
        if (!dealerCorner.depth2.values.includes(dealerCorner.depth2.default)) {
            showMessage(enqueueSnackbar, 'Choose default value for depth2 of dealer')
            return
        }

        if (dealerCorner.backWidth1.values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of backWidth1 of dealer')
            return
        }
        if (!dealerCorner.backWidth1.values.includes(dealerCorner.backWidth1.default)) {
            showMessage(enqueueSnackbar, 'Choose default value for backWidth1 of dealer')
            return
        }
        if (dealerCorner.backWidth2.values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of backWidth2 of dealer')
            return
        }
        if (!dealerCorner.backWidth2.values.includes(dealerCorner.backWidth2.default)) {
            showMessage(enqueueSnackbar, 'Choose default value for backWidth2 of dealer')
            return
        }

        if (designerCorner.width1.values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of width1 of designer')
            return
        }
        if (!designerCorner.width1.values.includes(designerCorner.width1.default)) {
            showMessage(enqueueSnackbar, 'Choose default value for width1 of designer')
            return
        }
        if (designerCorner.width2.values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of width2 of designer')
            return
        }
        if (!designerCorner.width2.values.includes(designerCorner.width2.default)) {
            showMessage(enqueueSnackbar, 'Choose default value for width2 of designer')
            return
        }

        if (designerCorner.height.values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of height of designer')
            return
        }
        if (!designerCorner.height.values.includes(designerCorner.height.default)) {
            showMessage(enqueueSnackbar, 'Choose default value for height of designer')
            return
        }

        if (designerCorner.depth1.values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of depth1 of designer')
            return
        }
        if (!designerCorner.depth1.values.includes(designerCorner.depth1.default)) {
            showMessage(enqueueSnackbar, 'Choose default value for depth1 of designer')
            return
        }
        if (designerCorner.depth2.values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of depth2 of designer')
            return
        }
        if (!designerCorner.depth2.values.includes(designerCorner.depth2.default)) {
            showMessage(enqueueSnackbar, 'Choose default value for depth2 of designer')
            return
        }

        if (designerCorner.backWidth1.values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of backWidth1 of designer')
            return
        }
        if (!designerCorner.backWidth1.values.includes(designerCorner.backWidth1.default)) {
            showMessage(enqueueSnackbar, 'Choose default value for backWidth1 of designer')
            return
        }
        if (designerCorner.backWidth2.values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of backWidth2 of designer')
            return
        }
        if (!designerCorner.backWidth2.values.includes(designerCorner.backWidth2.default)) {
            showMessage(enqueueSnackbar, 'Choose default value for backWidth2 of designer')
            return
        }


        const categoryProps = {
            name,
            forCorner,
            retail: retailCorner,
            dealer: dealerCorner,
            designer: designerCorner
        } as CategoryPropsType

        props.addCategory(categoryProps, enqueueSnackbar)

        setName('')
        setRetailCorner({ width1: { values: [], default: 0 }, width2: { values: [], default: 0 }, backWidth1: { values: [], default: 0 }, backWidth2: { values: [], default: 0 }, height: { values: [], default: 0 }, depth1: { values: [], default: 0 }, depth2: { values: [], default: 0 } })
        setDealerCorner({ width1: { values: [], default: 0 }, width2: { values: [], default: 0 }, backWidth1: { values: [], default: 0 }, backWidth2: { values: [], default: 0 }, height: { values: [], default: 0 }, depth1: { values: [], default: 0 }, depth2: { values: [], default: 0 } })
        setDesignerCorner({ width1: { values: [], default: 0 }, width2: { values: [], default: 0 }, backWidth1: { values: [], default: 0 }, backWidth2: { values: [], default: 0 }, height: { values: [], default: 0 }, depth1: { values: [], default: 0 }, depth2: { values: [], default: 0 } })
    }

    return (!forCorner ?
        <CategoryUIBox
            title='New Category'
            name={{
                value: name,
                onChange: handleNameChange
            }}
            displayName={{
                value: displayName,
                onChange: handleDisplayNameChange
            }}
            type={{
                value: forCorner ? 'corner' : 'normal',
                onChange: (e: React.ChangeEvent<{ value: string }>) => {
                    setForCorner(e.target.value === 'corner' ? true : false)
                }
            }}
            activeRole={{
                value: activeRole,
                onChange: (e: React.ChangeEvent<{ value: string }>) => {
                    setActiveRole(e.target.value)
                }
            }}
            activeRoleSizes={{
                value: activeRole === 'retail' ? retail : activeRole === 'dealer' ? dealer : designer,
                onChange: activeRole === 'retail' ? setRetail : activeRole === 'dealer' ? setDealer : setDesigner
            }}
            onButtonClick={handleCreateClick}
        />
        : <CornerCategoryUIBox
            title='New Category'
            name={{
                value: name,
                onChange: handleNameChange
            }}
            displayName={{
                value: displayName,
                onChange: handleDisplayNameChange
            }}
            type={{
                value: forCorner ? 'corner' : 'normal',
                onChange: (e: React.ChangeEvent<{ value: string }>) => {
                    setForCorner(e.target.value === 'corner' ? true : false)
                }
            }}
            activeRole={{
                value: activeRole,
                onChange: (e: React.ChangeEvent<{ value: string }>) => {
                    setActiveRole(e.target.value)
                }
            }}
            activeRoleSizes={{
                value: activeRole === 'retail' ? retailCorner : activeRole === 'dealer' ? dealerCorner : designerCorner,
                onChange: activeRole === 'retail' ? setRetailCorner : activeRole === 'dealer' ? setDealerCorner : setDesignerCorner
            }}
            onButtonClick={handleCornerCreateClick}
        />
    )
}

export default DefineCategory